import {HTMLProps, ReactNode} from "react";

import {Authentication} from "../../../model/Authentication";

import "./page.scss";
import {Helmet} from "react-helmet";

export interface PageProps extends Pick<HTMLProps<HTMLDivElement>, "className"> {
  children: ReactNode,
  auth?:  Authentication,

  /**
   * HTML meta data for the page
   */
  meta?: {
    /**
     * HTML>HEAD>TITLE
     */
    title: string;
    /**
     * HTML>HEAD>META[description]
     */
    description: string;
  };
}

export default function Page(props: PageProps) {
  const {
    children,
    className,
    meta
  } = props;
  return <div className={"Page-wrapper" + (className ? " " + className : "")}>
    {meta && (
        <Helmet>
          {meta.title && <title>{meta.title}</title>}
          {meta.description && (
              <meta name="description" content={meta.description} />
          )}
        </Helmet>
    )}
    <article className={"Page"}>
      {children}
    </article>
  </div>;
}
